import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateEventClosureReportMutationVariables = Types.Exact<{
  input: Types.CreateEventClosureReportInput;
}>;

export type CreateEventClosureReportMutation = {
  __typename?: 'Mutation';
  createEventClosureReport: {
    __typename?: 'CreateEventClosureReportResponse';
    eventClosureReportUuid?: string | null;
    message: string;
    success: boolean;
  };
};

export const CreateEventClosureReportDocument = gql`
  mutation CreateEventClosureReport($input: CreateEventClosureReportInput!) {
    createEventClosureReport(input: $input) {
      eventClosureReportUuid
      message
      success
    }
  }
`;
export type CreateEventClosureReportMutationFn = Apollo.MutationFunction<
  CreateEventClosureReportMutation,
  CreateEventClosureReportMutationVariables
>;
export function useCreateEventClosureReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEventClosureReportMutation,
    CreateEventClosureReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateEventClosureReportMutation,
    CreateEventClosureReportMutationVariables
  >(CreateEventClosureReportDocument, options);
}
export type CreateEventClosureReportMutationHookResult = ReturnType<
  typeof useCreateEventClosureReportMutation
>;
export type CreateEventClosureReportMutationResult =
  Apollo.MutationResult<CreateEventClosureReportMutation>;
export type CreateEventClosureReportMutationOptions =
  Apollo.BaseMutationOptions<
    CreateEventClosureReportMutation,
    CreateEventClosureReportMutationVariables
  >;
